const validWording = "Please enter valid "
const pleaseEnterWording = "Please enter "

//PolicyInformation
export const policyNumber =
  //"Please enter 8 character policy number starting with ‘D’"
  validWording + "policy number starting with ‘L’ , ‘Q’ , ‘E’ or ‘F’"
export const policyHolderName = validWording + "policyholder's full name"
export const policyHolderEmail = validWording + "policyholder's email"
export const policyHolderTel = validWording + "policyholder's telephone number"
export const otherInsurance = validWording + "details of other insurance"
export const claimantName = validWording + "claimant full name"
export const claimantEmail = validWording + "claimant email"
export const claimantMobile = validWording + "claimant telephone number"

//Loss Detail
export const claimAmount = validWording + "amount claimed"
export const claimDetail = validWording + "details of claims"
export const dateOfAccident = validWording + "date of accident"
export const timeOfAccident = validWording + "time of accident"
export const locationOfAccident = validWording + "location of accident"
export const descriptionOfAccident = validWording + "description of accident"
export const noticeDate = validWording + "date"
export const noticeDateEarlierThanAccident =
  "Date of Notice cannot be earlier than Date of Accident"
export const noticeTime = validWording + "time"
export const whoInform =
  validWording + "from whom did you receive the notice of the accident"
export const actionTaken =
  validWording + "immediate actions taken upon notification of the incident"
export const prevention =
  pleaseEnterWording + "how could you have prevented the incident"
export const liableForAccident =
  validWording +
  "state in your opinion whether you are liable for the incident and reasons"

export const futureTimeErrorMsg = "Future time is not allowed"
